function scrollToTop(ref) {
  ref.current.scrollTo(0, 0);
}
export default scrollToTop;
